<template lang="pug">
div
  div(v-if="orderByNum.length")
    draggable-container(v-model="orderByNum" @input="updateData($event)")
      div.dragging-wrapper(v-for="item in orderByNum" :key="JSON.stringify(item)")
        v-list-item.sorted-list
          span(style="max-width: 120px")
            slot(name="code" :item="item")
              span {{item.code}}
          span(style="margin-left: 30%; position: absolute")
            slot(name="name" :item="item")
              span {{item.name_short ? item.name_short : item.name}}
          v-spacer
          v-btn(icon @click.stop="changeItemPriority(item.id, 'down')")
            slot(name="icon")
              v-icon mdi-chevron-double-down
        v-divider
  div.pt-3
    .separated-line.py-1.pl-3(v-if="!disableType")
      span {{$t('message.items_sorted_by_name')}}
    div(v-for="item in orderNotByNum" :key="item.id" style="background: white")
      v-list-item.unsorted-list(:key="JSON.stringify(item)")
        span(style="max-width: 120px")
          slot(name="code" :item="item")
              span {{item.code}}
        span(style="margin-left: 30%; position: absolute")
          slot(name="name" :item='item')
              span {{item.name_short ? item.name_short : item.name}}
        v-spacer
        v-btn(icon @click.stop="changeItemPriority(item.id, 'up')")
          slot(name="icon")
            v-icon.list-item-icon mdi-chevron-double-up
      v-divider
</template>

<script lang="js">
import { defineComponent, toRefs, ref, watch } from 'vue'
import { orderBy } from 'lodash'
import DraggableContainer from '../DraggableContainer/index.vue'

const JMasterChangeOrderList = defineComponent({
  components: {
    DraggableContainer
  },
  props: {
    sortedItems: {
      type: Array,
      default: () => [],
      required: true
    },
    unsortedItems: {
      type: Array,
      default: () => [],
      required: true
    },
    isSortedAuctionOdrnum: {
      type: Boolean,
      default: false
    },
    disableType: {
      type: String,
      default: null
    }
  },
  setup(props, { emit }) {
    const { sortedItems, unsortedItems } = toRefs(props)
    const orderByNum = ref([])
    const orderNotByNum = ref([])
    const items = ref([])

    const itemsOrderBy = ref(
      props.isSortedAuctionOdrnum ? 'auction_odrnum' : 'odrnum'
    )
    const separateData = () => {
      orderByNum.value = orderBy([...sortedItems.value], itemsOrderBy.value)
      orderNotByNum.value = unsortedItems.value
    }

    // handle drop & drag
    const updateData = (events) => {
      const updatedOrder = events.map((el, index) => {
        // eslint-disable-next-line no-param-reassign
        el[itemsOrderBy.value] = index + 1
        return el
      })
      orderByNum.value = JSON.parse(JSON.stringify(updatedOrder))
      const updated = orderByNum.value.concat(orderNotByNum.value)
      emit('input', updated)
    }

    const changeItemPriority = (itemID, priority) => {
      if(
        (props.disableType === 'up' && priority === 'up')
        || (props.disableType === 'down' && priority === 'down')
      )
        return

      const isGoUp = priority === 'up'

      if (isGoUp) {
        // will be recalculate later
        orderNotByNum.value = orderNotByNum.value.filter((e) => {
          if (e.id === itemID) {
            orderByNum.value.push(e)
          }
          return e.id !== itemID
        })
      } else {
        orderByNum.value = orderByNum.value.filter((e) => {
          if (e.id === itemID) {
            e[itemsOrderBy.value] = null
            orderNotByNum.value.unshift(e)
          }
          return e.id !== itemID
        })
      }

      orderByNum.value = orderByNum.value.map((el, index) => {
        el[itemsOrderBy.value] = index + 1
        return el
      })
      const updated = orderByNum.value.concat(orderNotByNum.value)
      emit('input', updated)
    }

    const calculateHeight = (itemLength) => {
      let height
      if (itemLength * 50 < window.innerHeight) {
        height = itemLength * 50
      } else {
        height = window.innerHeight
      }
      return height
    }

    watch(
      [sortedItems, unsortedItems],
      ([newSortedVal, newUnsortedVal], [oldSortedVal, oldUnsortedVal]) => {
        if (
          (newSortedVal !== oldSortedVal, newUnsortedVal !== oldUnsortedVal)
        ) {
          separateData()
        }
      },
      { immediate: true }
    )
    return {
      orderByNum,
      orderNotByNum,
      items,
      changeItemPriority,
      updateData,
      calculateHeight
    }
  }
})

export default JMasterChangeOrderList
</script>

<style scoped lang="sass">
.actions-button
  bottom: 44px

.separated-line
  background-color: gray
  font-weight: 500
  color: #f7f7f7
</style>
